import senateVotesCsvString from "../csv/2021/state-sentate-votes"
import assemblyVotesCsvString from "../csv/2021/state-assembly-votes"
import supporters from "../csv/supporter-list"
import Papa from "papaparse"

export function getSenateVotes() {
  const { data: rows } = Papa.parse(senateVotesCsvString.trim(), {
    header: true,
  })

  rows.forEach(row => {
    row.District = Number(row.District.trim())
  })

  return rows
}

export function getAssemblyVotes() {
  const { data: rows } = Papa.parse(assemblyVotesCsvString.trim(), {
    header: true,
  })

  rows.forEach(row => {
    row.District = Number(row.District.trim())
  })

  return rows
}

export function getSupporters() {
  const { data: rows } = Papa.parse(supporters.trim(), {
    header: true,
  })

  return rows
}
